// Module-level flag that survives React StrictMode remounts.
// Set by PasswordChangeEntry when an external "change password" link
// arrives for a logged-in user; consumed when the modal is closed.

let pending = false

export const setPasswordChangeIntent = (value: boolean): void => {
    pending = value
}

export const getPasswordChangeIntent = (): boolean => pending